import { createFileRoute } from "@tanstack/react-router";
import HomePage from "@/site/pages/home";

interface HomeSearch {
  q?: string;
  /** A just-scheduled card send — opens the Card Send Control Center over the page. */
  sent?: string;
}

export const Route = createFileRoute("/home")({
  validateSearch: (search: Record<string, unknown>): HomeSearch => {
    const out: HomeSearch = {};
    if (typeof search.q === "string" && search.q.trim()) out.q = search.q;
    if (typeof search.sent === "string" && search.sent) out.sent = search.sent;
    return out;
  },
  component: HomePage,
});
